/**
 * LINKO 大門量度：智能門鎖適唔適合安裝。
 */
(function () {
  const LABELS = {
    material: { wood: '木門', iron: '鐵閘', fire: '防火門', glass: '玻璃門' },
    hole: { exist: '有現成圓孔（換鎖）', none: '新門未開孔', unsure: '唔確定' },
    backset: { '60': '60mm', '70': '70mm', unsure: '唔確定' },
  };

  function $(root, sel) {
    return root.querySelector(sel);
  }

  function selected(root, name) {
    const on = root.querySelector('[data-lf="' + name + '"].is-on');
    return on ? on.getAttribute('data-id') : '';
  }

  function setOn(root, name, id) {
    root.querySelectorAll('[data-lf="' + name + '"]').forEach(function (btn) {
      const on = btn.getAttribute('data-id') === String(id);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function evaluate(state, min, max) {
    if (state.material === 'glass') {
      return { level: 'no', title: '玻璃門通常唔適合呢款鎖', text: '一般智能門鎖要實心門扇。玻璃門請 WhatsApp 我哋睇專用方案。' };
    }
    if (state.material === 'iron') {
      return { level: 'maybe', title: '鐵閘要再確認型號', text: '鐵閘厚度同開孔同木門唔一樣，建議傳相或WhatsApp 我哋現場確認。' };
    }
    const unsure = !state.thick || state.thick === 'unsure';
    if (unsure) {
      return { level: 'maybe', title: '建議先量門厚', text: '用間尺量門邊最厚位置。香港木門多數 40–45mm。量完再計一次，或者 WhatsApp 傳相。' };
    }
    const t = Number(state.thick);
    if (!Number.isFinite(t)) {
      return { level: 'maybe', title: '建議先量門厚', text: '輸入門厚（毫米）之後再計。' };
    }
    if (t < min - 2) {
      return { level: 'no', title: '門太薄，呢款鎖未必夾得穩', text: '此鎖適用 ' + min + '–' + max + 'mm，你量到 ' + t + 'mm。WhatsApp 我哋睇有冇薄門方案。' };
    }
    if (t > max + 2) {
      return { level: 'no', title: '門太厚，可能要加長配件', text: '此鎖適用 ' + min + '–' + max + 'mm，你量到 ' + t + 'mm。請 WhatsApp 確認有冇加長螺絲／面板。' };
    }
    if (t < min || t > max) {
      return { level: 'maybe', title: '接近適用範圍，建議確認', text: '你量到 ' + t + 'mm，此鎖標示 ' + min + '–' + max + 'mm。最好 WhatsApp 傳相再定。' };
    }
    if (state.material === 'fire') {
      return { level: 'maybe', title: '防火門建議現場確認', text: '門厚 ' + t + 'mm 喺範圍內，但防火門內芯同開孔要現場睇。建議 WhatsApp 我哋再約量度。' };
    }
    if (state.hole === 'none') {
      return { level: 'maybe', title: '門厚合適，新門要開孔', text: '門厚 ' + t + 'mm 適合。新門要按鎖孔位開孔，LINKO 可以幫手或教你量邊距。' };
    }
    return { level: 'ok', title: '初步適合安裝', text: '門厚 ' + t + 'mm，喺此鎖 ' + min + '–' + max + 'mm 範圍內。實際以現場勘察為準，可用 WhatsApp 再確認。' };
  }

  function readState(root) {
    const num = $(root, '[data-lf-thick]');
    const chip = selected(root, 'thick');
    let thick = chip;
    if (num && num.value !== '') thick = String(Math.round(Number(num.value)));
    return {
      thick: thick,
      material: selected(root, 'material'),
      hole: selected(root, 'hole'),
      backset: selected(root, 'backset'),
    };
  }

  function thickLabel(thick) {
    if (!thick || thick === 'unsure') return '未量 / 唔確定';
    return thick + 'mm';
  }

  function shareHash(state) {
    const q = [
      't=' + encodeURIComponent(state.thick || ''),
      'm=' + encodeURIComponent(state.material || ''),
      'h=' + encodeURIComponent(state.hole || ''),
      'b=' + encodeURIComponent(state.backset || ''),
    ].join('&');
    return '#lock-fit&' + q;
  }

  function parseHash() {
    const hash = String(location.hash || '');
    if (hash.indexOf('#lock-fit') !== 0) return null;
    const out = {};
    hash.replace(/^#lock-fit&?/, '').split('&').forEach(function (part) {
      const i = part.indexOf('=');
      if (i < 1) return;
      out[part.slice(0, i)] = decodeURIComponent(part.slice(i + 1) || '');
    });
    return out;
  }

  function shareUrl(state) {
    return location.origin + location.pathname + location.search + shareHash(state);
  }

  function summaryLines(state, result, min, max, productTitle) {
    return [
      '🔐 產品：' + productTitle,
      '📏 門厚：' + thickLabel(state.thick) + '（此鎖適用 ' + min + '–' + max + 'mm）',
      '🪵 門材：' + (LABELS.material[state.material] || '未選'),
      '🔩 鎖孔：' + (LABELS.hole[state.hole] || '未選'),
      '📐 邊距：' + (LABELS.backset[state.backset] || '未選'),
      '結果：' + result.title,
    ];
  }

  function waHref(phone, text) {
    const base = phone ? 'https://wa.me/' + phone : 'https://wa.me/';
    return base + '?text=' + encodeURIComponent(text);
  }

  function paint(root, persist) {
    const min = Number(root.getAttribute('data-min') || 35);
    const max = Number(root.getAttribute('data-max') || 60);
    const productTitle = root.getAttribute('data-title') || '智能門鎖';
    const productUrl = root.getAttribute('data-url') || location.href;
    const phone = root.getAttribute('data-wa') || '85294013777';
    const prefixStaff = root.getAttribute('data-prefix-staff') || '你好 LINKO，我想確認呢把鎖適唔適合我屋企門：';
    const state = readState(root);
    const result = evaluate(state, min, max);
    const box = $(root, '[data-lf-result]');
    const ask = $(root, '[data-lf-wa-ask]');
    if (box) {
      box.hidden = false;
      box.setAttribute('data-level', result.level);
      box.innerHTML = '<p class="lf-result__kicker">' + (result.level === 'ok' ? '可以安裝' : result.level === 'no' ? '唔建議直接落單' : '建議再確認') + '</p><h3>' + result.title + '</h3><p>' + result.text + '</p>';
    }
    const lines = summaryLines(state, result, min, max, productTitle);
    const link = shareUrl(state);
    const staffText = [prefixStaff, '', lines.join('\n'), '', result.text, '', '產品：' + productUrl, '量度紀錄：' + link, '', '想問安裝同埋有冇貨。'].join('\n');
    if (ask) ask.setAttribute('href', waHref(phone, staffText));
    root.setAttribute('data-ready', '1');
    if (persist !== false) {
      try {
        history.replaceState({ lf: true }, '', location.pathname + location.search + shareHash(state));
      } catch (err) {}
    }
  }

  function applySaved(root, saved) {
    if (!saved) return;
    if (saved.t && saved.t !== 'unsure') {
      const num = $(root, '[data-lf-thick]');
      if (num) num.value = saved.t;
    }
    if (saved.t) setOn(root, 'thick', saved.t);
    if (saved.m) setOn(root, 'material', saved.m);
    if (saved.h) setOn(root, 'hole', saved.h);
    if (saved.b) setOn(root, 'backset', saved.b);
  }

  function bind(root) {
    root.addEventListener('click', function (ev) {
      const btn = ev.target.closest('[data-lf]');
      if (!btn) return;
      const name = btn.getAttribute('data-lf');
      const id = btn.getAttribute('data-id');
      setOn(root, name, id);
      if (name === 'thick') {
        const num = $(root, '[data-lf-thick]');
        if (num) num.value = id === 'unsure' ? '' : id;
      }
      paint(root);
    });
    const num = $(root, '[data-lf-thick]');
    if (num) {
      num.addEventListener('input', function () {
        if (num.value !== '') setOn(root, 'thick', String(Math.round(Number(num.value))));
        paint(root);
      });
    }
    applySaved(root, parseHash());
    paint(root, false);
  }

  function boot() {
    document.querySelectorAll('[data-lock-fit]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
